import { jsx as d } from "react/jsx-runtime";
import { useBuyOffer as p } from "../../pages/checkout/api/index.mjs";
import { BadRequest as w, createHttpClient as y } from "@systemeio/util";
import { useStore as g } from "../../store/index.mjs";
import { twJoin as b } from "tailwind-merge";
import h from "../../ui-kit/theme-button.mjs";
const B = y();
async function R(r) {
  const t = await B.get(r, {
    maxRedirects: 0
    // Prevent axios from automatically following redirects
  });
  if (t.status === 200) {
    window.location.assign(t.data.options.paypalLink);
    return;
  }
  if (t.status >= 300 && t.status < 400) {
    const o = t.headers.location;
    if (o) {
      window.location.assign(o);
      return;
    }
  }
  throw new Error("No redirect URL found");
}
function N({
  isFetching: r,
  buttonTitle: t,
  buttonDisabled: o,
  setIsFetching: n,
  preSubmit: a,
  handleBadRequest: i,
  hasErrors: s
}) {
  const { locale: c } = g(), { buyOffer: f } = p(), u = async (l) => {
    l.preventDefault(), n(!0);
    try {
      const e = a();
      if (!e) return;
      const { redirect: m } = await f(e, c);
      await R(m);
    } catch (e) {
      if (e instanceof w)
        i(e);
      else
        throw e;
    } finally {
      n(!1);
    }
  };
  return /* @__PURE__ */ d(
    h,
    {
      disabled: o,
      className: b("main-transition-colors", s && "bg-danger focus:bg-danger"),
      onClick: u,
      isFetching: r,
      type: "submit",
      children: t
    }
  );
}
export {
  N as PaypalRestPaymentButton,
  R as goToRedirect
};
